import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { InfoTip } from '../media/shared/InfoTip';
import { MediaCard } from '../media/shared/MediaCard';
import { CARD_TITLE_SX } from './layout';
import { useTrackTooltip } from './TooltipTracking';

interface DashboardCardProps {
  title: string;
  tip: string;
  height: number;
  children: ReactNode;
}

export function DashboardCard({ title, tip, height, children }: DashboardCardProps): ReactNode {
  const trackTooltip = useTrackTooltip();
  return (
    <MediaCard sx={{ height, px: 4, py: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography sx={CARD_TITLE_SX}>{title}</Typography>
        <InfoTip text={tip} onOpen={() => trackTooltip(title)} />
      </Box>
      {children}
    </MediaCard>
  );
}
